<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <span class="bg"></span>

        <LoginBrandingSection :loginParams="loginParams" />

        <v-col cols="12" md="7" class="pt-4">
          <v-container>
            <v-row justify="center">
             <LinksSection :other-links="loginParams.otherLinks" />
              <v-col cols="12" sm="8" md="8" lg="8">
                <LoginForm
                    :loginParams="loginParams"
                    :newsletter="newsletter.show"
                    :newsletterEmail="newsletterEmail"
                    :newsletterLoading="newsletterLoading"
                    @newsletter-email-changed="newsletterEmail = $event"
                    @subscribeNewsletter="subscribeNewsletter"
                    :model="model"
                    :isFormValid="isFormValid"
                    :loading="loading"
                    :modifiedSaml="modifiedSaml"
                    :modifiedSamlLogo="modifiedSamlLogo"
                    @login="login"
                    @recover="recover"
                    @samlLogin="samlLogin"
                    @signInWithEntraid="signInWithEntraid"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-container>
    </v-content>

    <app-core-footer class="footer-fixed" />

    <v-hover v-slot="{ hover }">
      <v-snackbar
        :elevation="hover ? 16 : 2"
        :timeout="hover ? -1 : 3000"
        top
        center
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn dark v-bind="attrs" @click.native="snackbar.show = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-hover>

    <RecoverModal :ref="recoverModalKey" />
    <TwoFactorAuthenticationEnrollModal
      :ref="twoFactorAuthenticationEnrollModalKey"
      @on-two-factor-authentication-enroll="onTwoFactorAuthenticationEnroll"
    />
  </v-app>
</template>
<script>
import RecoverModal from '@/components/login/RecoverModal.vue';
import TwoFactorAuthenticationEnrollModal from '@/components/login/TwoFactorAuthenticationEnrollModal.vue';
import LoginForm from './LoginForm.vue';
import UserService from '@/services/UserService';
import EntraIdService from '@/services/EntraIdService';
import { mapGetters } from 'vuex';
import LinksSection from './LinksSection.vue';
import LoginBrandingSection from './LoginBrandingSection.vue';
import Utils from '@/ecm/common/Utils';
import NewsLetterService from '../../services/NewsLetterService';

export default {
    components: {
        AppCoreFooter: () => import('../../components/core/Footer'),
        RecoverModal,
        TwoFactorAuthenticationEnrollModal,
        LoginForm,
        LinksSection,
        LoginBrandingSection
    },
    created() {
        if (this.$route.params.user_id != null && this.$route.params.device_id != null) {
            UserService.restoreDevice(
                this.$route.params.user_id,
                this.$route.params.device_id
            );
        } else if (this.$route.params.organization_id) {
            UserService.getSAMLAckForOrganization(this.$route.params.organization_id).then(response => {
                if (response.hasSettings) {
                    this.modifiedSamlLogo = `data:image/${response.logo.fileName.split('.').pop()};base64,${response.logo.file}`;
                    this.modifiedSaml = true;
                } else {
                    this.modifiedSaml = false;
                }
            });
        }
    },
    computed: {
        recoverModalInstance() {
            return this.$refs[this.recoverModalKey];
        },
        twoFactorAuthenticationEnrollModalInstance() {
            return this.$refs[this.twoFactorAuthenticationEnrollModalKey];
        },
        isFormValid() {
            return !!(this.model.username && this.model.password);
        },
        ...mapGetters({
            loginParams: 'account/loginParams',
        }),
        ...mapGetters({
            newsletter: 'account/newsletter',
        }),
    },
    data: () => ({
        loading: false,
        apiUrl: '',
        recoverModalKey: 'modalRecover',
        twoFactorAuthenticationEnrollModalKey: 'modalTwoFactorAuthenticationEnroll',
        model: {
            username: '',
            password: '',
        },
        snackbar: {
            show: false,
            text: '',
            color: '',
        },
        modifiedSaml: false,
        modifiedSamlLogo: null,
        newsletterLoading: false,
        newsletterEmail: '',
    }),
    methods: {
        async subscribeNewsletter(email) {
            if (!this.validateEmail(email)) {
                Utils.toast.error(this.$t('Site.NewsLetter.InvalidEmailFormat'));
                return;
            }

            this.newsletterLoading = true;

            try {
                const response = await NewsLetterService.subscribe(email);
                if (response) {
                    Utils.toast.success(this.$t('Site.NewsLetter.NewsletterSubscriptionSuccess'));
                    this.newsletterEmail = '';
                }
            } catch (error) {
                Utils.toast.error(this.$t('Site.NewsLetter.NewsletterSubscriptionError'));
            } finally {
                this.newsletterLoading = false;
            }
        },

        validateEmail(email) {
            if (!email || !email.trim()) return false;

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email.trim());
        },
        login(e) {
            if (e) {
                e.preventDefault();
            }
            this.loading = true;
            this.$store
                .dispatch('account/login', {
                    username: this.model.username,
                    password: this.model.password,
                })
                .then((resp) => {
                    this.loading = false;
                    this.setLocalStorageForOrganizationSamlSettings();
                })
                .catch((err) => {
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.error &&
                        err.response.data.error.includes('FuturaeActivationQRCodeURL')
                    ) {
                        this.twoFactorAuthenticationEnroll(
                            err.response.data.error.replace(
                                'FuturaeActivationQRCodeURL: ',
                                ''
                            )
                        );
                    }
                    this.loading = false;
                });
        },
        setLocalStorageForOrganizationSamlSettings() {
            if (this.$route.params.organization_id) {
                UserService.organizationHasSamlSettings(this.$route.params.organization_id).then(result => {
                    localStorage.setItem('organizationHasSamlSettings', result.toString());
                    window.getApp.$emit('APP_LOGIN_SUCCESS');
                });
            } else {
                localStorage.setItem('organizationHasSamlSettings', 'false');
                window.getApp.$emit('APP_LOGIN_SUCCESS');
            }
        },
        recover() {
            this.recoverModalInstance.new();
        },
        twoFactorAuthenticationEnroll(url) {
            this.twoFactorAuthenticationEnrollModalInstance.new(url);
        },
        onTwoFactorAuthenticationEnroll() {
            if (this.model.username != '' && this.model.password != '') this.login();
        },
        identityProviderLogin(sessionRequest) {
            this.loading = true;
            sessionRequest.then((identityProviderRequestResponse) => {
                window.open(identityProviderRequestResponse.RedirectURL, '_blank');
                this.$store
                    .dispatch('account/login', {
                        identity_provider_session_id:
                            identityProviderRequestResponse.SessionID,
                    })
                    .then((resp) => {
                        this.loading = false;
                        this.setLocalStorageForOrganizationSamlSettings();
                    })
                    .catch((err) => {
                        if (
                            err.response &&
                            err.response.data &&
                            err.response.data.error &&
                            err.response.data.error.includes('FuturaeActivationQRCodeURL')
                        ) {
                            this.twoFactorAuthenticationEnroll(
                                err.response.data.error.replace(
                                    'FuturaeActivationQRCodeURL: ',
                                    ''
                                )
                            );
                        }
                        this.loading = false;
                    });
            });
        },
        signInWithEntraid() {
            const sessionRequest = EntraIdService.EntraIdRequest();
            this.identityProviderLogin(sessionRequest);
        },
        samlLogin() {
            const sessionRequest = UserService.samlRequest(this.$route.params.organization_id);
            this.identityProviderLogin(sessionRequest);
        },
    },
};
</script>

<style scoped lang="css">
.bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: url("/static/login-background.svg") no-repeat center center;
  background-size: cover;
}

.border {
  border-width: 2px !important;
  border-style: solid !important;
  border-radius: 8px !important;
}

.footer-fixed {
  position: fixed;
  left: 0;
  width: 100%;
  z-index: 1;
}
</style>
